import type { ListProps as MuiListProps } from '@mui/material/List';

import MuiList from '@mui/material/List';
import React from 'react';

import Scrollbar from '../Scrollbar';

export type ListProps = MuiListProps;
const List = React.forwardRef(
  (props: ListProps, ref: React.ForwardedRef<HTMLUListElement>) => {
    return (
      <Scrollbar>
        <MuiList {...props} ref={ref}></MuiList>
      </Scrollbar>
    );
  },
);

List.displayName = 'List';

export default List;
